import React, {useEffect} from 'react';
import {getGradients} from '../../actions/gradientAction';
import {Link} from 'react-router-dom';
import {DashboardContainer,Box,Container,InlineContainer,TableContainer,DashboardNum,DashboardText,DashboardIcon,Table,Tr,Td,Th,Thead,Tbody,Tdl} from '../../styles/Dashboard-Styles.js'

import { useSelector, useDispatch } from "react-redux";

const Dashboard = () =>{
    const dispatch = useDispatch();
    const gradients = useSelector((state)=>state.gradient.gradients);
    useEffect(()=>{
        dispatch(getGradients());
    }, [dispatch]);
    return(
        <DashboardContainer>
        <Container>
        <InlineContainer>
          <Box>
          <InlineContainer>
              <DashboardIcon className={"material-icons"}>
                  palette
                </DashboardIcon>
                </InlineContainer>
                  <DashboardNum>
                      {gradients.length}
                  </DashboardNum>
                  <DashboardText>Gradients</DashboardText>
          </Box>
          <Box>
          <DashboardIcon className={"material-icons"}>
                  cloud_download
                </DashboardIcon>
              <DashboardNum>
                {gradients.map(gradient=>gradient.downloads).reduce((num,total)=>num+total,0)}
              </DashboardNum>
              <DashboardText>Downloads</DashboardText>
          </Box>
          <Link to ='/addgradient'><Box>
            <DashboardIcon className={"material-icons"}>
                  edit
                </DashboardIcon>
          </Box>
                </Link>
          </InlineContainer>
            <TableContainer>    
            <Table>
              <Thead>
                <Tr>
                   <Th>#</Th> 
                  <Th>name</Th>
                  <Th>downloads</Th>
                </Tr>
              </Thead>
              <Tbody>
                {
                    gradients.map(({name,downloads},index)=>(
                        index%2===0 ? <Tr>
                        <Tdl>{index+1}</Tdl>
                        <Tdl>{name}</Tdl>
                        <Tdl>{downloads}</Tdl>
                    </Tr> : <Tr>
                            <Td>{index+1}</Td>
                            <Td>{name}</Td>
                            <Td>{downloads}</Td>
                        </Tr>
                        
                    ))
                }
              </Tbody>
            </Table>
            </TableContainer>
            </Container>
      </DashboardContainer>
    )
}

export default Dashboard